(function () {
  const MOBILE_MQ = "(max-width: 991px)";

  function loadSwiper(callback) {
    if (typeof Swiper !== "undefined") {
      callback();
      return;
    }

    const existing = document.querySelector('script[data-el-swiper="true"]');
    if (existing) {
      if (typeof Swiper !== "undefined" || existing.dataset.loaded === "true") {
        callback();
        return;
      }
      existing.addEventListener("load", callback, { once: true });
      return;
    }

    if (!document.querySelector('link[data-el-swiper-css="true"]')) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
      link.dataset.elSwiperCss = "true";
      document.head.appendChild(link);
    }

    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
    script.dataset.elSwiper = "true";
    script.addEventListener(
      "load",
      () => {
        script.dataset.loaded = "true";
        callback();
      },
      { once: true }
    );
    document.body.appendChild(script);
  }

  function toggleStepsProgress(swiper, progress) {
    if (!progress) return;
    const shouldShow = Boolean(swiper) && !swiper.isLocked;
    progress.hidden = !shouldShow;
    progress.classList.toggle("is-visible", shouldShow);
  }

  function destroyStepsSwiper(section) {
    if (section._elSimpleStepsSwiper) {
      section._elSimpleStepsSwiper.destroy(true, true);
      delete section._elSimpleStepsSwiper;
    }
  }

  function cleanupVideosDom(slider) {
    if (!slider) return;
    slider.querySelectorAll(".swiper-slide-duplicate").forEach((el) => el.remove());
    slider.querySelectorAll("[data-el-loop-clone]").forEach((el) => el.remove());
    const wrapper = slider.querySelector(".swiper-wrapper");
    if (wrapper) {
      wrapper.removeAttribute("style");
    }
    slider.querySelectorAll(".swiper-slide").forEach((slide) => {
      slide.removeAttribute("style");
      slide.classList.remove(
        "swiper-slide-active",
        "swiper-slide-next",
        "swiper-slide-prev",
        "swiper-slide-fully-visible",
        "swiper-slide-visible"
      );
    });
  }

  function destroyVideosSwiper(section) {
    const slider = section.querySelector("[data-el-simple-steps-videos]");
    if (section._elSimpleStepsVideosSwiper) {
      section._elSimpleStepsVideosSwiper.destroy(true, true);
      delete section._elSimpleStepsVideosSwiper;
    }
    cleanupVideosDom(slider);
    delete section._elVideosOriginalCount;
  }

  /**
   * Prefixed + suffixed slide clones so first item can peek both sides
   * without Swiper's broken loop + centeredSlides behavior.
   * Returns original slide count (start index for the middle set).
   */
  function buildVideoLoopBuffer(slider) {
    const wrapper = slider.querySelector(".swiper-wrapper");
    if (!wrapper) return 0;

    wrapper.querySelectorAll("[data-el-loop-clone]").forEach((el) => el.remove());

    const originals = Array.from(
      wrapper.querySelectorAll(":scope > .swiper-slide")
    );
    if (originals.length < 2) return 0;

    originals.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.setAttribute("data-el-loop-clone", "before");
      wrapper.insertBefore(clone, originals[0]);
    });

    originals.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.setAttribute("data-el-loop-clone", "after");
      wrapper.appendChild(clone);
    });

    return originals.length;
  }

  /**
   * Teleport from clone buffers back to the middle set without a visible jump.
   * Shift translate by the exact slidesGrid delta so the clone and original
   * share the same screen position, then update the active index silently.
   */
  function normalizeVideoLoopIndex(swiper, section) {
    const count = section._elVideosOriginalCount;
    if (!count || !swiper || swiper.destroyed) return;

    const index = swiper.activeIndex;
    let newIndex = null;

    if (index < count) {
      newIndex = index + count;
    } else if (index >= count * 2) {
      newIndex = index - count;
    }

    if (newIndex === null || newIndex === index) return;

    const fromPos = swiper.slidesGrid[index];
    const toPos = swiper.slidesGrid[newIndex];
    const root = swiper.el;

    // Freeze card scale transitions while the active class hops clone → original
    if (root) root.classList.add("is-loop-jumping");

    if (typeof fromPos === "number" && typeof toPos === "number") {
      const diff = toPos - fromPos;
      swiper.setTransition(0);
      swiper.setTranslate(swiper.getTranslate() - diff);
    }

    swiper.slideTo(newIndex, 0, false);

    requestAnimationFrame(() => {
      if (root) root.classList.remove("is-loop-jumping");
    });
  }

  function videoRealIndex(swiper, section) {
    const count = section._elVideosOriginalCount;
    if (!count) return swiper.realIndex || swiper.activeIndex || 0;
    const index = swiper.activeIndex;
    if (index >= count && index < count * 2) return index - count;
    if (index < count) return index;
    return index - count * 2;
  }

  function getMode() {
    const width = window.innerWidth;
    if (width <= 580) return "mobile";
    if (width <= 991) return "tablet";
    return "desktop";
  }

  function slideCount(swiper) {
    const originals = swiper.el.querySelectorAll(
      ".swiper-slide:not(.swiper-slide-duplicate)"
    );
    return Math.max(originals.length, 1);
  }

  function updateVideosProgress(swiper, section) {
    const fill = section.querySelector(".el-simple-steps__videos-progress-fill");
    if (!fill) return;
    const total = section._elVideosOriginalCount || slideCount(swiper);
    const real = videoRealIndex(swiper, section);
    const ratio = ((real % total) + 1) / total;
    fill.style.width = `${ratio * 100}%`;
  }

  function postYouTubeCommand(iframe, command) {
    if (!iframe || !iframe.contentWindow) return;
    iframe.contentWindow.postMessage(
      JSON.stringify({ event: "command", func: command, args: [] }),
      "*"
    );
  }

  function buildEmbed(card) {
    const type = card.dataset.videoType;
    if (!type) return null;

    if (type === "shopify") {
      const src = card.dataset.videoSrc;
      if (!src) return null;
      const video = document.createElement("video");
      video.src = src;
      video.controls = false;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;
      video.muted = false;
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");
      video.disablePictureInPicture = true;
      video.setAttribute("controlsList", "nodownload noplaybackrate noremoteplayback");
      return video;
    }

    const id = card.dataset.videoId;
    if (!id) return null;

    const iframe = document.createElement("iframe");
    iframe.setAttribute(
      "allow",
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    );
    iframe.setAttribute("frameborder", "0");
    iframe.title = "Video review";
    iframe.dataset.videoHost = type;

    if (type === "youtube") {
      iframe.src =
        `https://www.youtube.com/embed/${id}` +
        `?autoplay=1&mute=0&controls=0&modestbranding=1&rel=0` +
        `&loop=1&playlist=${id}&playsinline=1&fs=0` +
        `&iv_load_policy=3&disablekb=1&cc_load_policy=0&enablejsapi=1`;
    } else if (type === "vimeo") {
      iframe.src =
        `https://player.vimeo.com/video/${id}` +
        `?autoplay=1&loop=1&muted=0&controls=0&title=0&byline=0&portrait=0&background=0`;
      iframe.dataset.videoHost = "vimeo";
    } else {
      return null;
    }

    return iframe;
  }

  function stopVideoCard(card) {
    if (!card) return;
    const player = card.querySelector("[data-el-video-player]");
    if (player) player.innerHTML = "";
    card.classList.remove("is-playing");
    card.classList.remove("has-media");
  }

  function pauseVideoCard(card) {
    if (!card) return;
    const player = card.querySelector("[data-el-video-player]");
    if (!player) return;

    const video = player.querySelector("video");
    if (video) {
      video.pause();
      card.classList.remove("is-playing");
      return;
    }

    const iframe = player.querySelector("iframe");
    if (iframe) {
      if (iframe.dataset.videoHost === "youtube") {
        postYouTubeCommand(iframe, "pauseVideo");
      } else if (iframe.dataset.videoHost === "vimeo") {
        iframe.contentWindow?.postMessage({ method: "pause" }, "*");
      }
      card.classList.remove("is-playing");
    }
  }

  function stopAllVideos(section, exceptCard) {
    section.querySelectorAll("[data-el-video-card]").forEach((card) => {
      if (exceptCard && card === exceptCard) return;
      stopVideoCard(card);
    });
  }

  function resumeEmbed(card) {
    const player = card.querySelector("[data-el-video-player]");
    if (!player) return false;

    const video = player.querySelector("video");
    if (video) {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {});
      }
      card.classList.add("is-playing");
      return true;
    }

    const iframe = player.querySelector("iframe");
    if (iframe) {
      if (iframe.dataset.videoHost === "youtube") {
        postYouTubeCommand(iframe, "playVideo");
      } else if (iframe.dataset.videoHost === "vimeo") {
        iframe.contentWindow?.postMessage({ method: "play" }, "*");
      }
      card.classList.add("is-playing");
      return true;
    }

    return false;
  }

  function playVideoCard(section, card) {
    if (!card) return;

    if (card.classList.contains("is-playing")) {
      pauseVideoCard(card);
      return;
    }

    if (card.classList.contains("has-media") && resumeEmbed(card)) {
      stopAllVideos(section, card);
      return;
    }

    const player = card.querySelector("[data-el-video-player]");
    if (!player) return;

    const embed = buildEmbed(card);
    if (!embed) return;

    stopAllVideos(section);
    player.innerHTML = "";
    player.appendChild(embed);
    card.classList.add("has-media");
    card.classList.add("is-playing");

    if (embed.tagName === "VIDEO") {
      const playPromise = embed.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {});
      }
    }
  }

  function bindInlineVideos(section) {
    if (section._elSimpleStepsVideosBound) return;
    section._elSimpleStepsVideosBound = true;

    section.addEventListener("click", (event) => {
      const card = event.target.closest("[data-el-video-card]");
      if (!card || !section.contains(card)) return;

      // Avoid stealing swiper arrow / nav clicks
      if (event.target.closest(".el-simple-steps__videos-nav")) return;

      event.preventDefault();
      event.stopPropagation();
      playVideoCard(section, card);
    });
  }

  function initStepsSlider(section) {
    const slider = section.querySelector(".el-simple-steps__blocks");
    const progress = section.querySelector(".el-simple-steps__progress");
    if (!slider) return;

    const isMobile = window.matchMedia(MOBILE_MQ).matches;

    if (!isMobile) {
      destroyStepsSwiper(section);
      toggleStepsProgress(null, progress);
      return;
    }

    if (typeof Swiper === "undefined") return;

    if (section._elSimpleStepsSwiper) {
      section._elSimpleStepsSwiper.update();
      toggleStepsProgress(section._elSimpleStepsSwiper, progress);
      return;
    }

    section._elSimpleStepsSwiper = new Swiper(slider, {
      slidesPerView: 1.5,
      spaceBetween: 12,
      slidesOffsetBefore: 15,
      slidesOffsetAfter: 15,
      loop: false,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      pagination: progress
        ? {
            el: progress,
            type: "progressbar",
          }
        : undefined,
      breakpoints: {
        581: {
          slidesPerView: 2.5,
          spaceBetween: 12,
          slidesOffsetBefore: 15,
          slidesOffsetAfter: 15,
        },
      },
      on: {
        init(instance) {
          toggleStepsProgress(instance, progress);
        },
        resize(instance) {
          toggleStepsProgress(instance, progress);
        },
        breakpoint(instance) {
          toggleStepsProgress(instance, progress);
        },
      },
    });
  }

  function initVideosSlider(section) {
    const slider = section.querySelector("[data-el-simple-steps-videos]");
    const prev = section.querySelector(".el-simple-steps__videos-arrow--prev");
    const next = section.querySelector(".el-simple-steps__videos-arrow--next");
    if (!slider || typeof Swiper === "undefined") return;

    const mode = getMode();
    if (section._elSimpleStepsVideosMode === mode && section._elSimpleStepsVideosSwiper) {
      section._elSimpleStepsVideosSwiper.update();
      updateVideosProgress(section._elSimpleStepsVideosSwiper, section);
      return;
    }

    destroyVideosSwiper(section);
    section._elSimpleStepsVideosMode = mode;

    const isMobile = mode === "mobile";
    const isTablet = mode === "tablet";
    let originalCount = slider.querySelectorAll(
      ".swiper-wrapper > .swiper-slide:not(.swiper-slide-duplicate):not([data-el-loop-clone])"
    ).length;

    // Clone buffers for infinite slide on all breakpoints (Swiper loop is unreliable here)
    if (originalCount >= 2) {
      originalCount = buildVideoLoopBuffer(slider) || originalCount;
      section._elVideosOriginalCount = originalCount;
    }

    const config = {
      spaceBetween: isMobile ? 8 : isTablet ? 12 : 28,
      speed: 450,
      watchOverflow: false,
      observer: false,
      observeParents: false,
      initialSlide: section._elVideosOriginalCount ? section._elVideosOriginalCount : 0,
      on: {
        init(swiper) {
          if (section._elVideosOriginalCount) {
            swiper.slideTo(section._elVideosOriginalCount, 0, false);
          }
          updateVideosProgress(swiper, section);
        },
        slideChange(swiper) {
          stopAllVideos(section);
          updateVideosProgress(swiper, section);
        },
        // Normalize only after the swipe settles — mid-transition jumps look obvious
        slideChangeTransitionEnd(swiper) {
          normalizeVideoLoopIndex(swiper, section);
          updateVideosProgress(swiper, section);
        },
        // Catch free-swipe landings that may skip transitionEnd in edge cases
        touchEnd(swiper) {
          requestAnimationFrame(() => {
            if (!swiper.animating) {
              normalizeVideoLoopIndex(swiper, section);
              updateVideosProgress(swiper, section);
            }
          });
        },
      },
    };

    if (isMobile) {
      // Fixed 201px slides (CSS) + our clone buffer = peeks both sides
      Object.assign(config, {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 8,
        loop: false,
        allowTouchMove: true,
      });
    } else {
      Object.assign(config, {
        slidesPerView: isTablet ? 2 : 4,
        centeredSlides: false,
        loop: false,
        allowTouchMove: true,
        navigation:
          prev && next
            ? {
                prevEl: prev,
                nextEl: next,
              }
            : undefined,
      });
    }

    section._elSimpleStepsVideosSwiper = new Swiper(slider, config);
  }

  function initSection(section) {
    bindInlineVideos(section);
    initStepsSlider(section);
    // Let mobile full-bleed styles paint before measuring slides
    requestAnimationFrame(() => initVideosSlider(section));
  }

  function destroySection(section) {
    stopAllVideos(section);
    destroyStepsSwiper(section);
    destroyVideosSwiper(section);
  }

  function boot(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll("[data-el-simple-steps]").forEach((section) => {
      initSection(section);
    });
  }

  let resizeTimer;
  window.addEventListener(
    "resize",
    () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => boot(), 150);
    },
    { passive: true }
  );

  loadSwiper(() => boot());

  document.addEventListener("shopify:section:load", (event) => {
    loadSwiper(() => boot(event.target));
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const section =
      event.target.querySelector?.("[data-el-simple-steps]") || event.target;
    const target = section?.matches?.("[data-el-simple-steps]")
      ? section
      : section?.querySelector?.("[data-el-simple-steps]");
    if (target) destroySection(target);
  });
})();
